(function () {
  function init(section) {
    if (!section || section.dataset.trProductReady === 'true') return;
    section.dataset.trProductReady = 'true';

    var gallery = section.querySelector('[data-tr-product-gallery]');
    if (gallery && gallery.dataset.trGalleryReady !== 'true') {
      gallery.dataset.trGalleryReady = 'true';
      var viewport = gallery.querySelector('[data-tr-gallery-viewport]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-tr-gallery-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-tr-product-thumb], [data-tr-gallery-thumb]'));
      var previous = gallery.querySelector('[data-tr-gallery-previous]');
      var next = gallery.querySelector('[data-tr-gallery-next]');
      var activeIndex = 0;
      var scrollFrame = 0;
      var drag = null;

      function clampIndex(index) {
        return Math.max(0, Math.min(index, slides.length - 1));
      }

      function syncGallery(index, centerThumbnail) {
        activeIndex = clampIndex(index);
        thumbs.forEach(function (thumb, thumbIndex) {
          var selected = thumbIndex === activeIndex;
          thumb.setAttribute('aria-current', selected ? 'true' : 'false');
          thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;
        if (centerThumbnail && thumbs[activeIndex]) {
          thumbs[activeIndex].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        }
      }

      function showImage(index, centerThumbnail) {
        if (!viewport || !slides.length) return;
        var targetIndex = clampIndex(index);
        viewport.scrollTo({ left: targetIndex * viewport.clientWidth, behavior: 'auto' });
        syncGallery(targetIndex, centerThumbnail !== false);
      }

      function syncFromScroll() {
        scrollFrame = 0;
        if (!viewport || !viewport.clientWidth || drag) return;
        syncGallery(Math.round(viewport.scrollLeft / viewport.clientWidth), true);
      }

      function queueScrollSync() {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(syncFromScroll);
      }

      function removeDragListeners() {
        window.removeEventListener('pointermove', onDragMove);
        window.removeEventListener('pointerup', endDrag);
        window.removeEventListener('pointercancel', endDrag);
        window.removeEventListener('blur', endDrag);
      }

      function endDrag() {
        if (!drag || !viewport) return;
        var completedDrag = drag;
        drag = null;
        removeDragListeners();
        viewport.classList.remove('is-dragging');
        var distance = completedDrag.lastX - completedDrag.startX;
        var threshold = Math.max(40, viewport.clientWidth * 0.12);
        var targetIndex = Math.round(viewport.scrollLeft / viewport.clientWidth);
        if (Math.abs(distance) >= threshold) {
          targetIndex = completedDrag.startIndex + (distance < 0 ? 1 : -1);
        }
        showImage(targetIndex, true);
      }

      function onDragMove(event) {
        if (!drag || !viewport || event.pointerType !== 'mouse') return;
        drag.lastX = event.clientX;
        if (Math.abs(drag.lastX - drag.startX) > 3) {
          viewport.classList.add('is-dragging');
          event.preventDefault();
        }
        viewport.scrollLeft = drag.startScroll - (drag.lastX - drag.startX);
      }

      if (viewport && slides.length) {
        viewport.addEventListener('scroll', queueScrollSync, { passive: true });
        viewport.addEventListener('pointerdown', function (event) {
          if (event.pointerType !== 'mouse' || event.button !== 0 || drag) return;
          drag = {
            startX: event.clientX,
            lastX: event.clientX,
            startScroll: viewport.scrollLeft,
            startIndex: activeIndex
          };
          window.addEventListener('pointermove', onDragMove, { passive: false });
          window.addEventListener('pointerup', endDrag);
          window.addEventListener('pointercancel', endDrag);
          window.addEventListener('blur', endDrag);
        });
        viewport.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          showImage(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      }

      thumbs.forEach(function (button, index) {
        button.addEventListener('click', function () {
          showImage(index, true);
        });
      });
      if (previous) previous.addEventListener('click', function () { showImage(activeIndex - 1, true); });
      if (next) next.addEventListener('click', function () { showImage(activeIndex + 1, true); });
      syncGallery(0, false);
    }

    var form = section.querySelector('product-form form');
    var submit = form && form.querySelector('[name="add"]');
    var variant = form && form.querySelector('[data-tr-product-variant]');
    var quantity = form && form.querySelector('[name="quantity"]');
    var price = section.querySelector('[data-tr-product-price]');
    var compare = section.querySelector('[data-tr-product-compare]');
    var availability = section.querySelector('[data-tr-product-availability]');
    var submitLabel = section.querySelector('[data-tr-product-atc-label]');
    var sticky = section.querySelector('[data-tr-product-sticky]');
    var stickyButton = section.querySelector('[data-tr-product-sticky-button]');
    var stickyPrice = section.querySelector('[data-tr-product-sticky-price]');

    function syncVariant() {
      if (!variant || !variant.selectedOptions.length) return;
      var option = variant.selectedOptions[0];
      var available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (stickyPrice) stickyPrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (availability) availability.textContent = available ? 'Available' : 'Currently unavailable';
      if (submit) {
        submit.disabled = !available;
        submit.toggleAttribute('data-unavailable', !available);
      }
      if (stickyButton) stickyButton.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (stickyButton) stickyButton.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (variant) variant.addEventListener('change', syncVariant);

    if (sticky && submit && form) {
      sticky.hidden = false;
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          if (!stickyButton.disabled && !submit.disabled) form.requestSubmit(submit);
        });
      }
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      observer.observe(submit);
      new MutationObserver(function () {
        if (stickyButton) stickyButton.disabled = submit.disabled;
      }).observe(submit, { attributes: true });
    }
    if (quantity) quantity.addEventListener('change', function () { if (quantity.valueAsNumber < 1) quantity.value = 1; });

    var buyerAccordions = section.querySelector('[data-tr-buyer-accordions]');
    if (buyerAccordions && buyerAccordions.dataset.trBuyerReady !== 'true') {
      buyerAccordions.dataset.trBuyerReady = 'true';
      var buyerItems = Array.prototype.slice.call(buyerAccordions.querySelectorAll('[data-tr-buyer-item]'));

      buyerItems.forEach(function (item) {
        var trigger = item.querySelector('[data-tr-buyer-trigger]');
        var panel = item.querySelector('[data-tr-buyer-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
          var shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

          buyerItems.forEach(function (candidate) {
            var candidateTrigger = candidate.querySelector('[data-tr-buyer-trigger]');
            var candidatePanel = candidate.querySelector('[data-tr-buyer-panel]');
            if (!candidateTrigger || !candidatePanel) return;
            var isOpen = candidate === item && shouldOpen;
            candidate.classList.toggle('is-open', isOpen);
            candidateTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            candidatePanel.hidden = !isOpen;
          });
        });
      });
    }

    var productFaq = section.querySelector('[data-tr-product-faq]');
    if (productFaq && productFaq.dataset.trFaqReady !== 'true') {
      productFaq.dataset.trFaqReady = 'true';
      var faqItems = Array.prototype.slice.call(productFaq.querySelectorAll('[data-tr-faq-item]'));

      faqItems.forEach(function (item) {
        var trigger = item.querySelector('[data-tr-faq-trigger]');
        var panel = item.querySelector('[data-tr-faq-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
          var shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

          faqItems.forEach(function (candidate) {
            var candidateTrigger = candidate.querySelector('[data-tr-faq-trigger]');
            var candidatePanel = candidate.querySelector('[data-tr-faq-panel]');
            if (!candidateTrigger || !candidatePanel) return;
            var isOpen = candidate === item && shouldOpen;
            candidate.classList.toggle('is-open', isOpen);
            candidateTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            candidatePanel.hidden = !isOpen;
          });
        });
      });
    }

    var experienceCarousel = section.querySelector('[data-tr-experience-carousel]');
    if (experienceCarousel && experienceCarousel.dataset.trExperienceReady !== 'true') {
      experienceCarousel.dataset.trExperienceReady = 'true';
      var experienceTrack = experienceCarousel.querySelector('[data-tr-experience-track]');
      var experienceCards = Array.prototype.slice.call(experienceCarousel.querySelectorAll('[data-tr-experience-card]'));
      var experiencePrevious = experienceCarousel.querySelector('[data-tr-experience-previous]');
      var experienceNext = experienceCarousel.querySelector('[data-tr-experience-next]');
      var experienceDots = Array.prototype.slice.call(experienceCarousel.querySelectorAll('[data-tr-experience-dot]'));
      var experienceIndex = 0;
      var experienceFrame = 0;
      var experienceReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function clampExperienceIndex(index) {
        return Math.max(0, Math.min(index, experienceCards.length - 1));
      }

      function syncExperience(index) {
        experienceIndex = clampExperienceIndex(index);
        if (experiencePrevious) experiencePrevious.disabled = experienceIndex === 0;
        if (experienceNext) experienceNext.disabled = experienceIndex === experienceCards.length - 1;
        experienceDots.forEach(function (dot, dotIndex) {
          if (dotIndex === experienceIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function showExperience(index) {
        if (!experienceTrack || !experienceCards.length) return;
        var targetIndex = clampExperienceIndex(index);
        var trackRect = experienceTrack.getBoundingClientRect();
        var cardRect = experienceCards[targetIndex].getBoundingClientRect();
        experienceTrack.scrollTo({
          left: experienceTrack.scrollLeft + cardRect.left - trackRect.left,
          behavior: experienceReducedMotion.matches ? 'auto' : 'smooth'
        });
        syncExperience(targetIndex);
      }

      function syncExperienceFromScroll() {
        experienceFrame = 0;
        if (!experienceTrack || !experienceCards.length) return;
        var trackLeft = experienceTrack.getBoundingClientRect().left;
        var nearestIndex = 0;
        var nearestDistance = Infinity;
        experienceCards.forEach(function (card, cardIndex) {
          var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = cardIndex;
          }
        });
        syncExperience(nearestIndex);
      }

      if (experienceTrack && experienceCards.length) {
        experienceTrack.addEventListener('scroll', function () {
          if (experienceFrame) return;
          experienceFrame = window.requestAnimationFrame(syncExperienceFromScroll);
        }, { passive: true });
        experienceTrack.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          showExperience(experienceIndex + (event.key === 'ArrowRight' ? 1 : -1));
        });
      }
      if (experiencePrevious) experiencePrevious.addEventListener('click', function () { showExperience(experienceIndex - 1); });
      if (experienceNext) experienceNext.addEventListener('click', function () { showExperience(experienceIndex + 1); });
      experienceDots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () { showExperience(dotIndex); });
      });
      syncExperience(0);
    }

    var reviewForm = section.querySelector('[data-tr-review-form]');
    var reviewRating = section.querySelector('[data-tr-review-rating]');
    var reviewStars = Array.prototype.slice.call(section.querySelectorAll('[data-tr-review-star]'));
    function selectReviewRating(value) {
      reviewStars.forEach(function (button) {
        var selected = Number(button.dataset.trReviewStar) <= Number(value);
        button.classList.toggle('is-selected', selected);
        button.textContent = selected ? '★' : '☆';
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (reviewRating) reviewRating.value = String(value);
    }
    reviewStars.forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', function () {
        selectReviewRating(button.dataset.trReviewStar);
        if (reviewForm) reviewForm.open = true;
        if (reviewRating) reviewRating.focus({ preventScroll: true });
      });
    });
    var writeReview = section.querySelector('[data-tr-write-review]');
    if (writeReview) writeReview.addEventListener('click', function () {
      if (reviewForm) reviewForm.open = true;
      if (reviewRating) reviewRating.focus({ preventScroll: true });
    });
    if (reviewRating && reviewRating.value) selectReviewRating(reviewRating.value);
    if (reviewForm && reviewForm.querySelector('.tr-product__form-success, .tr-product__form-errors')) reviewForm.open = true;

    var reviewMediaTitle = section.querySelector('.tr-product__media-title');
    var reviewMedia = section.querySelector('.tr-product__review-media');
    if (reviewMedia && reviewMedia.dataset.trNovaIllustrativeReady !== 'true') {
      var reviewMediaSources = [
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-01-handheld.png?v=1784355949',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-08-dim-bedroom-handheld.png?v=1784357302',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-02-unboxing.png?v=1784355972',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-09-dim-bathroom.png?v=1784357325',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-03-scale-phone.png?v=1784355993',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-10-dim-unboxing.png?v=1784357343',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-04-bathroom-hand.png?v=1784356013',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-11-dim-size-comparison.png?v=1784357379',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-05-cable-towels.png?v=1784356034',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-12-dim-nightstand.png?v=1784357400',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-06-box-tray.png?v=1784356056',
        'https://cdn.shopify.com/s/files/1/0785/3083/8873/files/tr-nova-review-media-07-size-comparison.png?v=1784356078'
      ];
      var reviewMediaPlaceholders = Array.prototype.slice.call(reviewMedia.children).filter(function (item) {
        return item.tagName === 'DIV' && item.textContent.trim() === 'Customer media';
      });

      if (reviewMediaPlaceholders.length) {
        if (reviewMediaTitle) reviewMediaTitle.textContent = 'Nova in everyday settings';

        if (reviewMediaTitle && !section.querySelector('.tr-product__review-media-note')) {
          var reviewMediaNote = document.createElement('p');
          reviewMediaNote.className = 'tr-product__review-media-note';
          reviewMediaNote.textContent = 'Lifestyle imagery shown for visual reference.';
          reviewMediaNote.style.margin = '-8px 0 16px';
          reviewMediaNote.style.textAlign = 'center';
          reviewMediaNote.style.fontSize = '12px';
          reviewMediaNote.style.lineHeight = '1.45';
          reviewMediaTitle.insertAdjacentElement('afterend', reviewMediaNote);
        }

        var initiallyVisible = window.matchMedia('(max-width: 820px)').matches ? 4 : 7;
        initiallyVisible = Math.min(initiallyVisible, reviewMediaSources.length);

        var remainingImages = Math.max(
          reviewMediaSources.length - initiallyVisible,
          0
        );

        var renderedReviewMedia = [];

        reviewMediaSources.forEach(function (source, index) {
          var placeholder = reviewMediaPlaceholders[index];

          if (!placeholder) {
            placeholder = document.createElement('div');
            reviewMedia.appendChild(placeholder);
          }

          placeholder.textContent = '';
          placeholder.setAttribute(
            'data-tr-nova-lifestyle-image',
            'true'
          );

          placeholder.style.position = 'relative';
          placeholder.style.overflow = 'hidden';

          var image = document.createElement('img');
          image.src = source;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.alt = 'Nova shown in an everyday home setting';
          placeholder.appendChild(image);

          if (index >= initiallyVisible) {
            placeholder.hidden = true;
            placeholder.style.display = 'none';
          } else {
            placeholder.hidden = false;
            placeholder.style.display = '';
          }

          renderedReviewMedia.push(placeholder);
        });

        if (
          remainingImages > 0 &&
          renderedReviewMedia[initiallyVisible - 1]
        ) {
          var moreTile = renderedReviewMedia[initiallyVisible - 1];

          var moreButton = document.createElement('button');
          moreButton.type = 'button';
          moreButton.setAttribute(
            'data-tr-nova-more-button',
            'true'
          );
          moreButton.setAttribute('aria-expanded', 'false');
          moreButton.setAttribute(
            'aria-label',
            'Show ' + remainingImages + ' more images'
          );

          moreButton.textContent = '+' + remainingImages + ' more';

          moreButton.style.position = 'absolute';
          moreButton.style.inset = '0';
          moreButton.style.zIndex = '2';
          moreButton.style.display = 'flex';
          moreButton.style.alignItems = 'center';
          moreButton.style.justifyContent = 'center';
          moreButton.style.width = '100%';
          moreButton.style.height = '100%';
          moreButton.style.padding = '12px';
          moreButton.style.border = '0';
          moreButton.style.borderRadius = 'inherit';
          moreButton.style.appearance = 'none';
          moreButton.style.background =
            'linear-gradient(180deg, rgba(24,18,19,.25), rgba(24,18,19,.84))';
          moreButton.style.color = '#fff';
          moreButton.style.font = 'inherit';
          moreButton.style.fontSize = '18px';
          moreButton.style.fontWeight = '700';
          moreButton.style.letterSpacing = '.02em';
          moreButton.style.cursor = 'pointer';
          moreButton.style.textShadow =
            '0 1px 8px rgba(0,0,0,.45)';

          moreButton.addEventListener('click', function () {
            renderedReviewMedia
              .slice(initiallyVisible)
              .forEach(function (item) {
                item.hidden = false;
                item.style.display = '';
              });

            moreButton.setAttribute('aria-expanded', 'true');
            moreButton.remove();
            reviewMedia.dataset.trNovaExpanded = 'true';
          });

          moreTile.appendChild(moreButton);
        }
      }

      reviewMedia.dataset.trNovaIllustrativeReady = 'true';
    }

  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tr-product-section]').forEach(init);
  }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

// trundes-live-review-cleanup-v4

// Trundes custom product page cache-safe version 5

// Trundes compact mobile reviews version 6
